<template>
  <div class="p-0 col-12 animated fadeIn" id="sales-logs">
    <kendo-datasource ref="datasource1"
                :transport-read="getSalesLog"
                :schema="getSalesSchema()"
                :schema-model-id="'uid'"
                :batch='true'
                :page-size='limit'
                :page="page"
                :server-paging='true'
                :server-sorting='true'
                :server-filtering='true'
                :sort="{ field: 'date', dir: 'desc' }">
    </kendo-datasource>
    <kendo-grid ref="gridComponent" :data-source-ref="'datasource1'"
                :filterable='true'
                :pageable="{ pageSizes: [10, 15, 25, 50], buttonCount: 3, input: true }"
                :sortable='false'
                :resizable='true'
                :page="pageChange"
                detail-template="#= detailTemplate(date.value, cs, partner, type.value, product.value, customer.value, approval, packing, shipping, price.value, shipment, discount, payment, channel, logistic) #">
      <kendo-grid-column field="status" title="&nbsp;" template="#= status.template(status.value(approval, packing, shipping)) #"
        :filterable="filters.status" :sortable="false" width="70px"></kendo-grid-column>
      <kendo-grid-column field="date" title="<i class='fa fa-calendar-alt'></i>" template="#= date.template #"
        :filterable="filters.date" :sortable='true' :min-screen-width="mdThreshold" width="120px" ></kendo-grid-column>
      <kendo-grid-column field="type" title="Sales Type" template="#= type.template #" width="150px"
        :filterable="getTypeFilters()" :sortable='false' :min-screen-width="mdThreshold" ></kendo-grid-column>
      <kendo-grid-column v-if="account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER'" field="cs"
        title="CS" :min-screen-width="mdThreshold" width="120px" template="#= cs.split(' - ')[1] #"
        :filterable="getCSFilters()" :sortable='false'></kendo-grid-column>
      <kendo-grid-column field="product" title="Carts" :filterable="getProductFilters()"
        template="#= product.template(product.value) #"></kendo-grid-column>
      <kendo-grid-column field="price" title="Prices" template="#= price.template(price.value) #" width="130px"
        :filterable="false" :min-screen-width="mdThreshold"></kendo-grid-column>
      <kendo-grid-column field="customer" title="Customer" :filterable="filters.customer" width="130px"
        template="#= customer.template #" :min-screen-width="mdThreshold"></kendo-grid-column>
      <kendo-grid-column width="115px" :template="actionTemplate"></kendo-grid-column>
    </kendo-grid>
  </div>
</template>

<script>
import moment from 'moment'
import SalesAction from '@/components/SalesAction'

export default {
  components: {
    SalesAction
  },
  data () {
    return {
      account: JSON.parse(localStorage.getItem('account')),
      button: {
        name: 'Add Sales',
        icon: 'fa fa-cart-plus',
        url: '/sales/add'
      },
      command: [],
      sales: [],
      filters: {
        status: {
          extra: false,
          operators: {
            string: { eq: 'equal to' }
          },
          ui: function (element) {
            element.kendoDropDownList({
              dataSource: [
                { value: 'waiting', text: 'Waiting' },
                { value: 'approved', text: 'Approved' }
              ],
              dataTextField: 'text',
              dataValueField: 'value'
            })
          }
        },
        date: {
          extra: false,
          ui: function (element) {
            element.kendoDatePicker({
              format: 'yyyy-MM-dd'
            })
          },
          operators: {
            string: {
              eq: 'equal to', gt: 'greater than', gte: 'greater than equal', lt: 'lower than', lte: 'lower than equal'
            }
          }
        },
        customer: {
          extra: false,
          operators: {
            string: { contains: 'contains', eq: 'exact' }
          }
        }
      },
      salesSchema: null,
      // pagination data
      limits: [ 10, 15, 25, 50 ],
      page: 1,
      totalPage: 1,
      limit: 15,
      offset: 0,
      count: 0,
      mdThreshold: 900,
      // filters
      dateFilters: [
        { value: '<', label: 'Date Before' },
        { value: '<=', label: 'Date Before or Equal' },
        { value: '=', label: 'Date Equal' },
        { value: '>=', label: 'Date After or Equal' },
        { value: '>', label: 'Date After' }
      ],
      dateFilter: { name: 'date', operand: '' }
    }
  },
  created () {
    // set culture
    window.kendo.culture('id-ID')
    // change button
    this.$parent.button = this.button
    // check route
    if (this.$route.query.page && parseInt(this.$route.query.page) > 0) {
      this.page = this.$route.query.page
    }
  },
  mounted () {
    // change button
    this.$parent.button = this.button
    if (this.$route.query.page && parseInt(this.$route.query.page) > 0) {
      this.page = this.$route.query.page
    }
  },
  methods: {
    actionTemplate (e) {
      var account = JSON.parse(localStorage.getItem('account'))
      e.vm = this
      e.account = account
      // console.log(e)
      return {
        template: SalesAction,
        templateArgs: e
      }
    },
    getSalesLog (event) {
      var vm = this
      vm.offset = (vm.page - 1) * vm.limit
      var sort = ''
      if (event.data.sort && event.data.sort.length > 0) {
        sort = event.data.sort[0].field + '-' + event.data.sort[0].dir
      }
      var filters = []
      if (event.data.filter) {
        filters = event.data.filter.filters
      }
      var filter = ''
      for (var i = 0; i < filters.length; i++) {
        var tempFilter = filters[i]
        if (tempFilter.field === 'date') {
          tempFilter.value = moment(tempFilter.value).format('YYYY-MM-DD')
        }
        filter += '&' + tempFilter.field + '=' + encodeURIComponent(tempFilter.value + ';' + tempFilter.operator)
      }
      var url = 'api/sales/logs/?limit=' + event.data.take + '&offset=' + event.data.skip
      if (this.account.role.toUpperCase() === 'CS') {
        url += '&cs=' + encodeURIComponent(this.account.code + ';' + 'EQ')
      }
      if (sort.length > 0) {
        url += '&sort=' + sort
      }
      if (filter.length > 0) {
        url += filter
      }
      vm.axios.get(url)
        .then(
          (response) => {
            console.log(response)
            event.success(response.data)
            window.scrollTo(100, 0)
          }
        )
    },
    getSalesSchema () {
      var vm = this
      return {
        total: 'count',
        data: 'results',
        parse: function (response) {
          var results = []
          var data = response.results
          for (var i = 0; i < data.length; i++) {
            var temp = data[i]
            var sale = {
              uidCode: temp.uid,
              status: {
                value: function (approval, packing, shipping) {
                  if (shipping.length > 0) {
                    return 'shipping'
                  }
                  if (packing.length > 0) {
                    return 'packing'
                  }
                  if (approval) {
                    return 'approved'
                  }
                  return 'waiting'
                },
                template: function (value) {
                  if (value === 'shipping') {
                    return '<span class="d-block text-center"><i class="fa fa-shipping-fast text-success" style="font-size: 20px">&nbsp;</i></span>'
                  } else if (value === 'packing') {
                    return '<span class="d-block text-center"><i class="fa fa-box-open text-info" style="font-size: 20px">&nbsp;</i></span>'
                  } else if (value === 'approved') {
                    return '<span class="d-block text-center"><i class="fa fa-check-circle text-primary" style="font-size: 20px">&nbsp;</i></span>'
                  }
                  return '<span class="d-block text-center"><i class="fa fa-clock text-warning" style="font-size: 20px">&nbsp;</i></span>'
                }
              },
              type: {
                value: temp.outbound_type,
                template: '<span class="d-block text-uppercase">' + temp.outbound_type + '</span>'
              },
              date: {
                value: temp.created_at,
                template: '<span class=\'d-block text-center\'><span class=\'d-inline text-uppercase\'></i>&nbsp; ' + moment(temp.created_at).format('DD MMM YY') + '</span></span>'
              },
              cs: temp.cs_detail.code + ' - ' + temp.cs_detail.fullname,
              partner: data[i].partner_detail,
              product: {
                value: temp.cart,
                template: function (carts) {
                  var strTemplate = '<table>'
                  for (var i = 0; i < carts.length; i++) {
                    strTemplate += '<tr><td class="px-1 py-2 text-capitalize">' + carts[i].product.name.toLowerCase() + '</td>' +
                                    '<td class="px-1 py-2 text-right" width="20px" style="border: none">' + carts[i].qty + '</td></tr>'
                  }
                  strTemplate += '</table>'
                  return strTemplate
                }
              },
              price: {
                value: temp.price,
                template: function (value) {
                  var val = (value / 1).toFixed(0).replace('.', ',')
                  var valStr = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                  return '<span>IDR</span><span class=\'float-right\'>' + valStr + '</span>'
                }
              },
              customer: {
                value: temp.customer,
                template: '<span class=\'d-block text-capitalize\'>' + temp.customer.name.toLowerCase() + '</span>'
              },
              payment: {
                account: temp.account_name,
                time: temp.payment_time
              },
              channel: temp.channel,
              logistic: temp.logistic,
              approval: temp.approval_time,
              packing: temp.packing,
              shipping: temp.shipping,
              discount: temp.discounts,
              shipment: temp.cost.shipment,
              detailTemplate: function (date, cs, partner, type, product, customer, approval, packing, shipping, price, shipment, discount, payment, channel, logistic) {
                var detail = '<div class="row m-0">'
                // status
                var status = '<span class="d-inline-block"><i class="fa fa-clock text-warning" style="font-size: 20px">&nbsp;</i>Waiting for Approval</span>'
                if (shipping.length > 0) {
                  status = '<span class="d-inline-block "><i class="fa fa-shipping-fast text-success" style="font-size: 20px">&nbsp;</i>Product Shipped</span>'
                } else if (packing.length > 0) {
                  status = '<span class="d-inline-block "><i class="fa fa-box-open text-info" style="font-size: 20px">&nbsp;</i>Packing Done</span>'
                } else if (approval) {
                  status = '<span class="d-inline-block "><i class="fa fa-check-circle text-primary" style="font-size: 20px">&nbsp;</i>Sales Approved</span>'
                }
                detail += '<div class="col-12 p-0" style="margin-bottom: 10px">' + status + '<span class="d-inline-block text-uppercase" >&nbsp;&nbsp;&nbsp;(' + moment(date).format('DD MMMM YY') + ')</span></div>'
                // cs
                detail += '<div class="col-6 col-md-3 p-0">Sales Person</div><div class="col-6 col-md-3 p-0 value-field">' +
                          '<span class="text-capitalize">' + cs + '</span></strong></div>'
                // sales type
                detail += '<div class="col-6 col-md-3 p-0">Sales Type</div><div class="col-6 col-md-3 p-0 value-field">' +
                          '<span class="text-uppercase">' + type + '</span></strong></div>'
                // sales channel
                detail += '<div class="col-6 col-md-3 p-0">Channel</div><div class="col-6 col-md-3 p-0 value-field">' +
                          '<span class="text-uppercase">' + channel + '</span></strong></div>'
                // sales logistic
                detail += '<div class="col-6 col-md-3 p-0">Logistic</div><div class="col-6 col-md-3 p-0 value-field">' +
                          '<span class="text-uppercase">' + logistic + '</span></strong></div>'
                detail += '<hr class="col-12"/>'
                // customer data
                var internal = ''
                if ('internal' in customer && customer.internal === true) {
                  internal = '(INTERNAL)'
                }
                var email = '-'
                if (customer.email !== null && typeof (customer.email) !== 'undefined') {
                  email = customer.email
                }
                if (!customer.notes) {
                  customer.notes = '-'
                }
                var partnerName = ''
                if (partner) {
                  partnerName = partner.name
                }
                detail += '<div class="col-12 col-md-6 p-0 m-0"><div class="row m-0">'
                detail += '<div class="col-6 p-0"><span class="d-block">Customer Name</span></div>'
                detail += '<div class="col-6 p-0 text-capitalize"><span class="d-block">' + customer.name.toLowerCase() + ' ' + internal + '</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">Phone Number</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">' + customer.phone + '</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">Email</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">' + email.toLowerCase() + '</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">Address</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block text-capitalize">' + customer.address.toLowerCase() + '</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">Notes</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">' + customer.notes + '</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">Sales Partner</span></div>'
                detail += '<div class="col-6 p-0"><span class="d-block">' + partnerName + '</span></div>'
                detail += '</div></div>'
                detail += '<hr class="col-12 d-md-none"/>'
                // carts & prices
                detail += '<div class="col-12 col-md-6 p-0"><table class="detail-table" style="width: 100%; border: none">'
                var carts = product
                detail += '<tr><td class="px-1 py-2 text-capitalize">Bank Account</td>' +
                          '<td class="px-1 py-2 text-capitalize" style="border: none">' + payment.account.toLowerCase() + '</td>' +
                          '</tr>'
                detail += '<tr><td class="px-1 py-2 text-capitalize">Payment Time</td>' +
                          '<td class="px-1 py-2 text-capitalize" style="border: none">' + moment(payment.time).format('DD-MM-YYYY HH:mm') + '</td>' +
                          '</tr>'
                detail += '<tr><td colspan="2" style="padding-top: 10px !important">Carts</td></tr>'
                for (var i = 0; i < carts.length; i++) {
                  var val = carts[i].qty * carts[i].product.price
                  detail += '<tr><td class="px-1 py-2 text-capitalize" width="50%">' + carts[i].product.name.toLowerCase() + ' <strong>' + carts[i].qty + '</strong> ' + carts[i].product.unit + '</td>' +
                            '<td class="px-1 py-2" style="border: none">' + window.kendo.toString(val, 'c') + '</td>' +
                            '</tr>'
                }
                var shippingCost = 0
                if (shipment !== null && typeof (shipment) !== 'undefined') {
                  shippingCost = shipment
                }
                detail += '<tr><td class="px-1 py-2 text-capitalize">Shipping Cost</td>' +
                          '<td class="px-1 py-2" style="border: none">' + window.kendo.toString(shippingCost, 'c') + '</td>' +
                          '</tr>'
                detail += '<tr><td class="px-1 py-2 text-capitalize">Total Discount</td>' +
                          '<td class="px-1 py-2" style="border: none">' + window.kendo.toString(parseFloat(discount), 'c') + '</td>' +
                          '</tr>'
                detail += '<tr><td class="px-1 py-2 text-capitalize" style="padding-top: 10px !important"><strong>Final Price</strong></td>' +
                          '<td class="px-1 py-2" style="border-left: none;">' + window.kendo.toString(parseFloat(price), 'c') + '</td>' +
                          '</tr>'
                detail += '</table></div>'
                // total div
                if (packing.length > 0) {
                  detail += '<hr class="col-12"/>'
                  detail += '<div class="col-md-6 col-12 p-0"><table class="detail-table"><tr><td colspan="2">Packing</td></tr>'
                  var resources = packing[0].resources
                  for (var ii = 0; ii < resources.length; ii++) {
                    detail += '<tr>'
                    detail += '<td class="px-1 py-2 text-capitalize">' + resources[ii].name + '</td>'
                    detail += '<td style="border:none" class="text-capitalize">' + resources[ii].usage + ' ' + resources[ii].unit + '</td>'
                  }
                  detail += '</table></div>'
                  if (shipping.length > 0) {
                    var shippingDetail = shipping[0]
                    detail += '<div class="col-md-6 col-12 p-0"><table class="detail-table"><tr><td colspan="2">Shipping</td></tr>'
                    detail += '<tr><td class="px-1 py-2 text-capitalize">Shipping Document</td>'
                    detail += '<td style="border:none">' + shippingDetail.document_code + '</td></tr>'
                    detail += '<tr><td class="px-1 py-2 text-capitalize">Pickup Time</td>'
                    detail += '<td style="border:none">' + moment(shippingDetail.pickup_time).format('DD-MM-YYYY HH:mm') + '</td>'
                    detail += '</table></div>'
                  }
                }
                // ending div
                detail += '</div>'
                return detail
              },
              getCommand: function (uid, date, cs, type, product, customer, approval, packing, shipping, price, shipment, discount, payment) {
                var page = 1
                if ('page' in vm.$route.query) {
                  page = vm.$route.query.page
                }
                var command = '<div class="col-12 p-0 text-center">'
                var account = JSON.parse(localStorage.getItem('account'))
                var code = cs.toUpperCase().split(' - ')[0]
                if (((approval === null || typeof (approval) === 'undefined') && (code === account.code)) || (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER')) {
                  command += '<a href="/#/sales/edit/' + uid + '" class="btn btn-outline-warning btn-block btn-sm" style="width: 80%">Edit</a>'
                }
                if ((approval === null || typeof (approval) === 'undefined') && (account.role.toUpperCase() === 'FINANCE' || account.role.toUpperCase() === 'MANAGER')) {
                  if ('places' in customer) {
                    delete customer.places
                  }
                  var jsonProduct = JSON.stringify(product).split('"').join('\\\'')
                  var jsonCustomer = JSON.stringify(customer).split('\'').join('').split('"').join('\\\'').split('&quot;').join('')
                  var jsonPayment = JSON.stringify(payment).split('\'').join('').split('"').join('\\\'').split('&quot;').join('')
                  command += '<button class="btn btn-outline-primary btn-block btn-sm" style="width: 80%" onClick="approveConfirm(\'' + process.env.API_SERVER + '\',\'' + uid + '\',\'' + date + '\',\'' + cs + '\',\'' + type + '\',\'' + jsonProduct + '\',\'' + jsonCustomer + '\',' + price + ',' + shipment + ',' + discount + ',\'' + jsonPayment + '\')">Approve</button>'
                }
                if (approval && packing.length > 0 && (account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'WAREHOUSE')) {
                  var labelShipment = 'Shipping'
                  var btnClass = 'btn-outline-warning'
                  if (shipping.length > 0) {
                    btnClass = 'btn-outline-success'
                  }
                  command += '<a href="/#/inventory/shipping/' + uid + '?return=' + page.toString() + '" class="btn ' + btnClass + ' btn-block btn-sm" style="width: 80%">' + labelShipment + '</a>'
                }
                if (approval && (account.role.toUpperCase() === 'MANAGER' || account.role.toUpperCase() === 'WAREHOUSE')) {
                  var labelPacking = 'Packing'
                  btnClass = 'btn-outline-warning'
                  if (packing.length > 0) {
                    btnClass = 'btn-outline-success'
                  }
                  command += '<a href="/#/inventory/packing/' + uid + '?return=' + page.toString() + '" class="btn ' + btnClass + ' btn-block btn-sm" style="width: 80%">' + labelPacking + '</a>'
                }
                command += '</div>'
                return command
              }
            }
            results.push(sale)
          }

          response.results = results
          return response
        }
      }
    },
    getProductFilters () {
      var vm = this
      return {
        extra: false,
        operators: {
          string: { eq: 'equal to', neq: 'not equal to' }
        },
        ui: function (element) {
          element.kendoMultiSelect({
            optionLabel: '-- select product --',
            dataSource: {
              serverFiltering: true,
              transport: {
                read: function (event) {
                  var filter = event.data.filter
                  var q = ''
                  if (filter && filter.filters && filter.filters.length > 0) {
                    q = filter.filters[0].value
                  }
                  if (q.length > 0) {
                    vm.axios.get('api/sales/products/search/' + encodeURIComponent(q) + '/')
                      .then(
                        (response) => {
                          event.success(response.data)
                        }
                      )
                  } else {
                    vm.axios.get('api/sales/products/?sort=' + encodeURIComponent('name-asc'))
                      .then(
                        (response) => {
                          event.success(response.data.results)
                        }
                      )
                  }
                }
              },
              schema: {
                parse: function (response) {
                  for (var i = 0; i < response.length; i++) {
                    response[i].name = response[i].name.toUpperCase()
                  }
                  return response
                }
              }
            },
            dataTextField: 'name',
            dataValueField: 'code',
            valuePrimitive: true
          })
        }
      }
    },
    getTypeFilters () {
      var vm = this
      return {
        extra: false,
        operators: {
          string: { eq: 'equal to', neq: 'not equal to' }
        },
        ui: function (element) {
          element.kendoDropDownList({
            dataSource: {
              serverFiltering: false,
              transport: {
                read: function (event) {
                  vm.axios.get('api/inventory/outbound/type/')
                    .then(
                      (response) => {
                        event.success(response.data)
                      }
                    )
                }
              }
            },
            dataTextField: 'name',
            dataValueField: 'name'
          })
        }
      }
    },
    getCSFilters () {
      var vm = this
      return {
        extra: false,
        operators: {
          string: { eq: 'equal to', neq: 'not equal to' }
        },
        ui: function (element) {
          element.kendoMultiSelect({
            optionLabel: '-- select cs --',
            dataTextField: 'name',
            dataValueField: 'code',
            valuePrimitive: true,
            dataSource: {
              serverFiltering: true,
              transport: {
                read: function (event) {
                  vm.axios.get('api/user/account/')
                    .then(
                      (response) => {
                        event.success(response)
                      }
                    )
                }
              },
              schema: {
                data: 'data',
                parse: function (response) {
                  console.log(response)
                  var datas = []
                  var data = response.data
                  for (var i = 0; i < data.length; i++) {
                    var temp = data[i]
                    var cs = {
                      code: temp.code.toString(),
                      name: temp.fullname.toString()
                    }
                    datas.push(cs)
                  }
                  response.data = datas
                  return response
                }
              }
            }
          })
        }
      }
    },
    formatPrice (value) {
      var val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    redirectTo (uri) {
      this.$router.push(uri)
    },
    pageChange (event) {
      console.log(event)
      this.$router.push('/sales?page=' + event.page)
    }
  }
}
</script>

<style scoped>
  .table td {
    padding: 0.5rem;
    vertical-align: middle;
  }

  .limit-select {
    min-width: 50px;
    border: none;
    border-bottom: solid 1px;
    border-radius: 0px;
    background: transparent;
    box-shadow: none;
    height: 30px;
  }

  .dd {
    font-weight: bold;
  }
  .mm {
    text-transform: uppercase;
  }

  #pagination-item {
    text-align: right;
  }

  .btn-filter {
    background: transparent;
    border: none;
    color: #848484;
  }

  .btn-filter:hover {
    color: #636363;
  }

  .btn-filter:focus {
    color: #212121;
  }

  .dropdown-filter.dropdown-menu-right {
    transform: translate3d(-90px, 55px, 0px) !important;
  }

  @media screen and (max-width: 600px) {
    #pagination-item {
      text-align: center;
    }

    #limit-filter {
      text-align: center;
      margin-bottom: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/sales/SalesLog.vue